import { IModuleConfig } from 'redux-state/layout/types.modules.js';

export enum ModuleTypeEnum {
  ModuleStatic = 'ModuleStatic',
  ModuleDynamic = 'ModuleDynamic',
}
export type ModuleTypeStatic = { module: ModuleTypeEnum.ModuleStatic };
export type ModuleTypeDynamic = { module: ModuleTypeEnum.ModuleDynamic; dynamicUrl: string };

type ModuleType = ModuleTypeStatic | ModuleTypeDynamic;

export type IModuleConfigState = { type: ModuleType; data: IModuleConfig };

export type SecondaryModulesState = Record<
  'secondaryMajor' | 'secondaryMinor' | 'secondaryRight',
  IModuleConfigState[]
>;
